import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Trans, translate } from 'react-i18next';

import { formatCurrency } from 'helpers/format';

export const Credits = ({ t, customerCredit }) => {
  const balance = customerCredit ? parseFloat(customerCredit.balance) : 0;
  const credits = customerCredit
    ? formatCurrency(balance, customerCredit.currency)
    : '-';

  return (
    <div className="aside__item">
      <h4>{t('overview.credits.heading')}</h4>

      <h5 className="aside__value">{credits}</h5>

      <div className="aside__description">
        {balance > 0 && (
          <Trans i18nKey="overview.credits.description">
            This means you’ll get a {{ credits }} discount off of your next
            cleaning!
          </Trans>
        )}

        {balance === 0 && (
          <Trans i18nKey="overview.credits.descriptionNone">
            You currently don't have any credits. Learn more about{' '}
            <Link to="/get-discount">how to start earning credits</Link>.
          </Trans>
        )}
      </div>
    </div>
  );
};

Credits.propTypes = {
  t: PropTypes.func.isRequired,
  customerCredit: PropTypes.object.isRequired
};

export default translate()(Credits);



// WEBPACK FOOTER //
// ./src/components/Credits/Credits.js